// import Quill from "quill";
// const size = Quill.import("attributors/style/size");
// // size.whitelist = ["10px", "14px", "18px", "24px"];
// Quill.register(size, true)
export class HtmlEditorConstants {
    static MAX_IMAGE_SIZE = 300000;
    static MAX_IMAGE_MESSAGE = `The image size exceeds the maximum size limit ${HtmlEditorConstants.MAX_IMAGE_SIZE / 1000}mb`;
    static HTML_EDITOR_MAX_LENGTH = 5000;
    static HTML_ADD_APPLICATION_LINK = "Add application link";
    static HTML_EDITOR_STYLE = {
        height: "200px",
        width: "100%"
    };
    static HTML_TOOLBAR = [
        [{ size: ["10px", false, "18px", "24px"] }, { color: [] }],
        ["italic", "bold", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
        ["link", "image"],
    ];
    static HTML_EDITOR_CONFIG = {
        toolbar: {
            container: HtmlEditorConstants.HTML_TOOLBAR
        },
    };
    static HTML_TOOLBAR_NOIMAGE = [
        [{ size: ["10px", false, "18px", "24px"] }, { color: [] }],
        ["italic", "bold", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
        ["link"],
    ];
    static HTML_EDITOR_CONFIG_NOIMAGE = {
        toolbar: {
            container: HtmlEditorConstants.HTML_TOOLBAR_NOIMAGE
        },
    };
}
